module.exports = __webpack_public_path__ + "static/media/image-6.6f6e5310.jpg";